"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "pognana-lario": {
    "7eab3ca2": [{
      "hkey": "829e7e26",
      "slug": "pognana-lario",
      "name": "Pognana Lario",
      "primary": true,
      "skipSearch": false
    }],
    "canzaga": [{
      "hkey": "829e7e26",
      "slug": "pognana-lario",
      "name": "Pognana Lario",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5c268f61": [{
      "hkey": "829e7e26",
      "slug": "pognana-lario",
      "name": "Pognana Lario",
      "primary": true,
      "skipSearch": false
    }],
    "quarzano": [{
      "hkey": "829e7e26",
      "slug": "pognana-lario",
      "name": "Pognana Lario",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d8b32104": [{
      "hkey": "829e7e26",
      "slug": "pognana-lario",
      "name": "Pognana Lario",
      "primary": true,
      "skipSearch": false
    }],
    "riva": [{
      "hkey": "829e7e26",
      "slug": "pognana-lario",
      "name": "Pognana Lario",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "61e63dc1": [{
      "hkey": "829e7e26",
      "slug": "pognana-lario",
      "name": "Pognana Lario",
      "primary": true,
      "skipSearch": false
    }],
    "rovasco": [{
      "hkey": "829e7e26",
      "slug": "pognana-lario",
      "name": "Pognana Lario",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;